import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Button from '../Button'

const base = "overview-header";

@inject("RiderStore")
@observer
class OverviewHeader extends Component {
  render() {
    const { RiderStore } = this.props;
    return (
      <div className={`${base} bg--white`}>
        <div className="display--flex pll prl ptm pbm">
          <div className={`${base}__left`}>
            <div>
              <input
                type="text"
                placeholder="Search by rider name"
                onChange={RiderStore.handleChange}
                value={RiderStore.riderSearch}
              />
            </div>
          </div>
          <div className={`${base}__right margin--left`}>
            <div>
              <a href="/check-in">
                <Button 
                  content={'Rider check in'}
                  style={{padding: "10px 36px"}}
                />
                {/* <button className={`${base}__check-in`}>Rider check in</button> */}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OverviewHeader;



// WEBPACK FOOTER //
// ./src/components/overview/OverviewHeader.js